registerComponent("sections/wa-topo", function (component) {
/**
 * sections/wa-topo — a primeira dobra da LP do WhatsApp.
 *
 * O VÍDEO DA FAIXA e o BOTÃO DE SOM valem SEMPRE (não são animação: são o
 * conteúdo e o controle dele). O resto só com movimento permitido; sem ele o
 * CSS fica no estado final, inteiro e parado:
 *
 * 1. arma a ENTRADA das peças (`.entrada`, `_entrada.less` / ADR 0051) em DOIS
 *    grupos: a dobra (título, lead, ação, aparelho) e as três tags. ⚠️ As
 *    tags ficam ABAIXO da faixa, fora da primeira tela — armadas junto com a
 *    dobra, no desktop elas entravam no carregamento e o cliente as achava
 *    paradas quando chegava nelas (23/09). Cada grupo entra quando ELE chega.
 *    No celular a dobra não tem entrada: o CSS anula o "antes" dela (25/09);
 * 2. a TRANSIÇÃO DO MONOGRAMA ATÉ A BARRA (`Asa.transicaoDoTopo`, ADR 0043),
 *    a mesma das outras páginas (23/09, pedido do cliente): a rolagem encolhe
 *    o monograma até o centro da barra enquanto as duas linhas se dissolvem.
 *    O alcance é o de "Sobre o ASA" — 390 na âncora de 1440 —, com a faixa de
 *    mídia como teto. ⚠️ A CONSTRUÇÃO DO MONOGRAMA (`Asa.marcaAnimada`) do site
 *    novo não veio: o cliente a tirou de todas as páginas em 18/09;
 * 3. o PARALLAX do quadro onde não há `animation-timeline: scroll()` (onde há,
 *    é CSS puro, ver `_wa-topo.less`).
 *
 * E, com ou sem movimento:
 * · marca `js-topo-encostado` no <html> no quadro em que a BASE DA FAIXA passa
 *   pela base da barra. A página põe `header--acima header--acima-celular`, o
 *   que deixa a barra TRANSPARENTE para a foto passar por baixo dela (é o que
 *   o frame desenha); dali em diante o conteúdo que sobe é branco, e a nav —
 *   que é branca — precisa do fundo. As regras já existem em `_header.less`:
 *   o `::before` acende (ADR 0073) e o `.header__logo` entra (ADR 0102) — e,
 *   nesta página, a assinatura já pousada apaga no mesmo quadro;
 * · CARREGA o vídeo só depois do `load` da página (CWV-018) — até lá quem
 *   ocupa a faixa é o pôster, que é o LCP;
 * · PAUSA o vídeo quando a página cobre a faixa (e a esconde) e o retoma na
 *   volta — com som ligado, ele não continua tocando por baixo do conteúdo.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

/* ⚠️ ESTA PÁGINA RECARREGA NO TOPO (24/09, pedido do cliente: "ao carregar o
   site não comece scrollado"). O site deixa a rolagem com o navegador de
   propósito (ADR 0056): um F5 no meio de uma página volta ao mesmo ponto.
   Aqui o hero fica PRESO e é coberto pela página, e voltar no meio dela abria
   a LP com o vídeo já meio escondido e o monograma na barra — parecia que a
   página tinha começado "levemente para baixo". Só nesta página, então, o
   navegador não restaura a rolagem, e a página abre em y=0. Uma âncora na URL
   (`#…`) continua valendo: é o navegador que rola até ela. */
if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

if (!window.location.hash) {
    window.scrollTo(0, 0);
}

const media = component.querySelector('.wa-topo__media');
const video = component.querySelector('.wa-topo__video');
const som = component.querySelector('.wa-topo__som');
const header = document.querySelector('.header');
const raiz = document.documentElement;
const conteudo = component.querySelector('.wa-topo__conteudo');

/* O que fazer com o vídeo quando a faixa é coberta ou volta — definido no bloco
   do vídeo, abaixo; sem vídeo, nada. */
let tocar = () => {};

/* ── O VÍDEO E O BOTÃO DE SOM ────────────────────────────────────────────────
   O `<video>` só existe quando `heroVideo` está preenchido nos dados da página
   (ver lá). Sem ele o botão nasce `disabled` pelo HTML e fica assim: o desenho
   do frame continua na tela, mas não finge ser acionável.

   Com vídeo: ele entra por cima do quadro-pôster no `canplay` — antes disso a
   troca piscaria no primeiro quadro decodificado — e o botão passa a alternar
   `muted`. O ícone mostra o ESTADO (mudo = alto-falante com X), e não a ação;
   quem descreve a ação é o `aria-label`, que troca junto.

   ⚠️ O ENDEREÇO SÓ ENTRA DEPOIS DO `load` (CWV-018). O markup traz `data-src`
   e nenhum `autoplay`: com o vídeo na carga inicial, os 605 KB disputavam a
   banda com o pôster e o LCP do celular ia a 12,6 s no 4G simulado. Até 768
   vale o `data-src-celular`, quando existe — a faixa ali tem 220 de altura. */
if (video && som) {
    const acender = () => component.classList.add('wa-topo--video-pronto');
    let carregado = false;

    /* Coberta pela página, a faixa some e o vídeo para (e o som junto); de
       volta, ele segue de onde estava. Quem decide é a rolagem (abaixo), e não
       um `IntersectionObserver`: a faixa é `fixed` e está sempre "na tela".
       `play()` devolve promessa e pode ser recusado (economia de bateria, aba
       oculta): a recusa não é erro, o pôster continua ali. */
    tocar = (coberta) => {
        /* Antes do `src`, um `play()` dispararia o download na hora. */
        if (!carregado) {
            return;
        }

        if (coberta) {
            video.pause();
            return;
        }

        if (video.paused) {
            const p = video.play();

            if (p && typeof p.catch === 'function') {
                p.catch(() => {});
            }
        }
    };

    video.addEventListener('canplay', acender, { once: true });

    /* Coberta na hora do `load` (rolou antes), só grava o endereço: o download
       começa quando a faixa voltar, pelo `play()` do `tocar`. */
    const carregar = () => {
        if (carregado) {
            return;
        }

        carregado = true;
        video.src = (Asa.celular.matches && video.dataset.srcCelular) || video.dataset.src;
        tocar(component.classList.contains('wa-topo--faixa-coberta'));
    };

    if (document.readyState === 'complete') {
        carregar();
    } else {
        window.addEventListener('load', carregar, { once: true });
    }

    const icone = som.querySelector('.wa-topo__som-icone');

    const pintar = () => {
        const mudo = video.muted;

        som.disabled = false;
        som.setAttribute('aria-pressed', String(!mudo));
        som.setAttribute('aria-label', mudo ? component.dataset.somLigar : component.dataset.somDesligar);

        if (icone) {
            icone.classList.toggle('icon--sound-off', mudo);
            icone.classList.toggle('icon--sound-on', !mudo);
        }
    };

    som.addEventListener('click', () => {
        carregar();
        video.muted = !video.muted;

        Asa.track('media_control', { target_id: 'wa_topo_video', state: video.muted ? 'sound_off' : 'sound_on' });

        /* Alguns navegadores só deixam sair do mudo dentro do gesto; se o
           vídeo estiver pausado por causa disso, o play volta aqui. */
        if (video.paused) {
            const p = video.play();

            if (p && typeof p.catch === 'function') {
                p.catch(() => {});
            }
        }

        pintar();
    });

    pintar();
}

/* O TOPO DA FOLHA DO CONTEÚDO no documento — onde a faixa acaba. A faixa é
   `fixed` e não tem posição no documento; quem guarda o lugar dela é o
   `padding-top` da seção, e a folha começa exatamente na base dela. Remedido a
   cada rajada porque a altura da faixa é `rem`/`svh` e muda com a janela. */
const topoDaFolha = () => (conteudo ? conteudo.getBoundingClientRect().top + window.scrollY : 0);

/* O TOPO DA PRIMEIRA PEÇA QUE PASSA POR CIMA DA FAIXA. Acima de 768 é o
   APARELHO, que sobe 137 além da folha (é absoluto na grade); abaixo ele volta
   ao fluxo, depois do texto, e quem chega primeiro é a folha. `offsetTop`, e
   não o retângulo, porque a entrada (`.entrada`) desloca o aparelho por
   `transform` enquanto não entrou. */
const aparelho = component.querySelector('.wa-topo__aparelho');
const inner = component.querySelector('.wa-topo__inner');
const topoDaCobertura = () => {
    const folha = topoDaFolha();

    if (!aparelho || !inner) {
        return folha;
    }

    return Math.min(folha, folha + inner.offsetTop + aparelho.offsetTop);
};

/* A barra ganha o fundo POUCO ANTES de a cobertura encostar nela (23/09, pedido
   do cliente): o aparelho passava por baixo da barra ainda transparente, com a
   nav sobre a tela dele. A antecipação de 40 é o que o fade de 0,45s do
   `::before` (ver `_wa-topo.less`) precisa para já estar pintado no quadro do
   toque, numa rolagem normal. `offsetHeight` do header e não `--header-h`: o
   valor computado já vem com a régua aplicada. */
const alcance = () => {
    const rem = parseFloat(getComputedStyle(raiz).fontSize) || 1;

    return Math.max(0, topoDaCobertura() - (header ? header.offsetHeight : 0) - 40 * rem);
};

/* 390 na âncora de 1440 — o alcance de "Sobre o ASA" (477,81 − 88, desde o
   monograma de 61 × 66; o site novo usava os 472 da régua antiga), em `rem`
   para acompanhar a régua do `:root` —, e nunca além da faixa: o monograma
   tem de pousar antes de a barra ganhar o fundo. */
const alcanceDaMarca = () => {
    const rem = parseFloat(getComputedStyle(raiz).fontSize) || 1;

    return Math.min(390 * rem, alcance());
};

if (Asa.movimentoPermitido()) {
    Asa.armarEntrada(
        [component.querySelector('.wa-topo__inner'), component.querySelector('.wa-topo__selos')],
        '.entrada'
    );

    /* ⚠️ ATÉ 1024 A AÇÃO É A BARRA FIXA NO PÉ DA JANELA, e o observador da
       entrada nunca a revelaria: ele espera a peça estar 15% para dentro da
       tela, e a barra mora justamente nos 15% de baixo (medido em 900 × 1200:
       opacidade 0 e 32 abaixo da janela, para sempre). Ela está sempre à
       vista, então entra no carregamento, como a primeira dobra. */
    const acao = component.querySelector('.wa-topo__acao');
    const cta = component.querySelector('.wa-topo__cta');
    const revelarAcao = () => {
        // Tagueamento (plano v3.1): até 1024 este CTA é a barra fixa do pé.
        if (cta) cta.dataset.trackOrigin = Asa.desktop.matches ? 'assistant_topo' : 'assistant_barra';

        if (acao && !Asa.desktop.matches) {
            Asa.revelar(acao);
        }
    };

    revelarAcao();
    Asa.desktop.addEventListener('change', revelarAcao);

    Asa.transicaoDoTopo(component, {
        medir: alcanceDaMarca,
        classeNativo: 'wa-topo--nativo',
        propAlcance: '--wa-alcance',
        propT: '--wa-t',
    });

    /* AS PÍLULAS SEGUEM O MOUSE E A ROLAGEM (24/09, pedido do cliente: "um leve
       parallax no movimento do mouse + scroll"). Só com mouse de verdade. Cada
       pílula tem uma PROFUNDIDADE — a da direita, mais baixa na diagonal, é a
       mais "perto" e anda mais —, e o deslocamento é pequeno: até 8 × 6 pelo
       mouse e 12 pela rolagem na mais funda. Um quadro por mudança, escrito em
       `--selo-px`/`--selo-py`; a suavidade é a transição de 0,9s do
       `translate` (ver o `_wa-topo.less`). */
    const selos = Array.from(component.querySelectorAll('.wa-topo__selo'));
    const mouseFino = window.matchMedia('(hover: hover) and (pointer: fine)');

    if (selos.length) {
        const profundidade = [0.6, 1, 1.4];
        let nx = 0;
        let ny = 0;
        let pendente = false;

        const pintar = () => {
            pendente = false;

            const rem = parseFloat(getComputedStyle(raiz).fontSize) || 1;
            const ligado = mouseFino.matches;

            selos.forEach((selo, i) => {
                if (!ligado) {
                    selo.style.removeProperty('--selo-px');
                    selo.style.removeProperty('--selo-py');
                    return;
                }

                const p = profundidade[i] || 1;
                const b = selo.getBoundingClientRect();
                // −1 no alto da janela, +1 no pé: a pílula sobe um pouco mais
                // devagar que a página enquanto passa pela tela.
                const naTela = Math.max(-1, Math.min(1, ((b.top + b.height / 2) / window.innerHeight) * 2 - 1));
                const x = nx * 8 * p;
                const y = ny * 6 * p + naTela * 12 * p;

                selo.style.setProperty('--selo-px', `${(x * rem).toFixed(2)}px`);
                selo.style.setProperty('--selo-py', `${(y * rem).toFixed(2)}px`);
            });
        };

        const agendar = () => {
            if (!pendente) {
                pendente = true;
                requestAnimationFrame(pintar);
            }
        };

        const aoMover = (evento) => {
            if (evento.pointerType !== 'mouse') {
                return;
            }

            nx = (evento.clientX / window.innerWidth) * 2 - 1;
            ny = (evento.clientY / window.innerHeight) * 2 - 1;
            agendar();
        };

        /* ⚠️ SÓ COM AS PÍLULAS NA TELA (24/09, o cliente notou mais CPU
           navegando): o `pointermove` ficava ligado na janela inteira e
           remedia as três pílulas a cada movimento do mouse, em qualquer ponto
           da página. Agora o ouvinte só existe enquanto a fileira está à
           vista — o observador o liga e desliga —, e a rolagem também só
           remede aí. Fora da tela as pílulas guardam o último deslocamento,
           que ninguém vê. */
        let aVista = false;

        Asa.aoRolar(() => {
            if (aVista) {
                agendar();
            }
        });
        mouseFino.addEventListener('change', agendar);

        const fileira = component.querySelector('.wa-topo__selos');

        if (fileira && 'IntersectionObserver' in window) {
            new IntersectionObserver(([entrada]) => {
                if (entrada.isIntersecting === aVista) {
                    return;
                }

                aVista = entrada.isIntersecting;

                if (aVista) {
                    window.addEventListener('pointermove', aoMover, { passive: true });
                    agendar();
                } else {
                    window.removeEventListener('pointermove', aoMover);
                }
            }).observe(fileira);
        }
    }

    /* O PARALLAX SEM `animation-timeline` (Firefox, Safari < 26): o mesmo
       `translate` do `@keyframes wa-topo-parallax` — o quadro SOBE 20% da
       rolagem enquanto a folha cobre a faixa —, escrito a cada quadro de
       rolagem. Coberta a faixa, o último valor fica. */
    const quadro = component.querySelector('.wa-topo__quadro');
    const nativo = typeof CSS !== 'undefined'
        && typeof CSS.supports === 'function'
        && CSS.supports('animation-timeline: scroll()');

    if (quadro && media && !nativo) {
        Asa.aoRolar((y) => {
            const rolado = Math.min(media.offsetHeight, Math.max(0, y));

            quadro.style.translate = `0 ${Math.round(rolado * -0.2 * 10) / 10}px`;
        });
    }
}

/* O RECORTE ARREDONDADO DA FAIXA sem `animation-timeline` (ver "o canto
   arredondado acompanha a folha" no `_wa-topo.less`): o pé da faixa é cortado
   na linha da folha, com os 64 do canto. Vale com ou sem movimento — é a
   geometria da cobertura, não um efeito. Só acima de 768, onde há canto. */
const recorteNativo = typeof CSS !== 'undefined'
    && typeof CSS.supports === 'function'
    && CSS.supports('animation-timeline: scroll()');

if (media && !recorteNativo) {
    Asa.aoRolar((y) => {
        if (Asa.celular.matches) {
            media.style.clipPath = '';
            return;
        }

        const corte = Math.min(media.offsetHeight, Math.max(0, y));
        const raio = parseFloat(getComputedStyle(raiz).fontSize) * 64;

        media.style.clipPath = `inset(0 0 ${corte}px 0 round 0 0 ${raio}px ${raio}px)`;
    });
}

/* A TROCA DA BARRA vale COM OU SEM movimento permitido: não é animação, é o
   fundo que a nav precisa para continuar legível. Um quadro por rajada, pelo
   agendador de `Asa.aoRolar`. */
Asa.aoRolar((y) => {
    const limite = alcance();

    raiz.classList.toggle('js-topo-encostado', limite > 0 && y >= limite);

    /* COBERTA quando a folha passa do alto da janela (no celular, da base da
       barra, onde a faixa está presa): daí a faixa não aparece mais em lugar
       nenhum e some, com o vídeo parado. */
    const topoDaFaixa = media ? media.getBoundingClientRect().top : 0;
    const coberta = y >= topoDaFolha() - topoDaFaixa;

    if (coberta !== component.classList.contains('wa-topo--faixa-coberta')) {
        component.classList.toggle('wa-topo--faixa-coberta', coberta);
        tocar(coberta);
    }
});

});
